export default __webpack_public_path__ + "static/media/sangeetha shanbhogue.37276ef6.jpg";